import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";

export default function CenterPage() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  return (
    <div className="min-h-screen bg-neutral-900 text-neutral-100 px-4 py-6 md:px-8">
      {/* 顶部标题区 */}
      <div className="max-w-4xl mx-auto space-y-4">
        <div className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-primary to-primary-light bg-clip-text text-transparent">
          {translate(getText("挖礦賺不停"))}
        </div>
        
        <div className="text-neutral-400 text-sm md:text-base">
          {translate(getText("鎖倉挖礦是通過將USDT託管給平台超算力礦機在平台礦池中進行挖礦收益"))}
        </div>

        {/* 产品亮点区 */}
        <div className="mt-8 space-y-6">
          <div className="text-xl font-medium text-neutral-200">
            {translate(getText("產品亮點"))}
          </div>

          {/* 特点卡片 */}
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-neutral-800/50 rounded-lg p-4 hover:bg-neutral-800 transition">
              <div className="text-primary font-medium">
                {translate(getText("隨存隨取"))}
              </div>
              <div className="text-neutral-400 text-sm mt-1">
                {translate(getText("派息周期"))}
              </div>
            </div>
            <div className="bg-neutral-800/50 rounded-lg p-4 hover:bg-neutral-800 transition">
              <div className="text-primary font-medium">
                {translate(getText("每日下發"))}
              </div>
              <div className="text-neutral-400 text-sm mt-1">
                {translate(getText("活期利息"))}
              </div>
            </div>
          </div>

          {/* 图标特点区 */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="flex items-center space-x-3 bg-neutral-800/30 rounded-lg p-4">
              <img src="/lokup/0.svg" alt="" className="w-8 h-8" />
              <div className="text-sm text-neutral-300">
                {translate(getText("100%資金安全保障"))}
              </div>
            </div>
            <div className="flex items-center space-x-3 bg-neutral-800/30 rounded-lg p-4">
              <img src="/lokup/1.svg" alt="" className="w-8 h-8" />
              <div className="text-sm text-neutral-300">
                {translate(getText("節假日收益不間斷"))}
              </div>
            </div>
            <div className="flex items-center space-x-3 bg-neutral-800/30 rounded-lg p-4">
              <img src="/lokup/2.svg" alt="" className="w-8 h-8" />
              <div className="text-sm text-neutral-300">
                {translate(getText("成功存入後當前起息"))}
              </div>
            </div>
          </div>
        </div>

        {/* 示例说明区 */}
        <div className="mt-8 space-y-4">
          <div className="text-xl font-medium text-neutral-200">
            {translate(getText("舉個例子"))}
          </div>
          <div className="bg-neutral-800/30 rounded-lg p-6 space-y-2">
            <div className="text-primary-light font-medium">
              {translate(getText("計算收益"))}
            </div>
            <div className="text-neutral-400 text-sm leading-relaxed"
              dangerouslySetInnerHTML={{
                __html: translate(
                  getText(
                    "會員在平台鎖倉10000U，選擇了周期為5天，日產出為鎖倉金額的0.3%的理財產品，則每天產出如下：<br>10000UX0.3%=30U</br> 即5天後可以獲得150U的收益，鎖倉本金到期後，本金收益自動轉入您的資產帳戶。"
                  )
                ),
              }}
            />
          </div>
        </div>

        {/* 违约金说明区 */}
        <div className="mt-8 space-y-4">
          <div className="text-xl font-medium text-neutral-200">
            {translate(getText("關於違約金"))}
          </div>
          <div className="bg-neutral-800/30 rounded-lg p-6">
            <div className="text-neutral-400 text-sm leading-relaxed"
              dangerouslySetInnerHTML={{
                __html: translate(
                  getText(
                    "若您希望轉出未到期的本金，則會產生違約金，違約金=違約結算比例*剩餘天數*鎖倉數量。 <br>舉例:該鎖倉挖礦的違約結算比例為0.4%，剩餘3天到期，鎖倉數量為1000，則違約金=0.4%*3*1000=12U。 違約金將直接從本金中扣除。</br>"
                  )
                ),
              }}
            />
          </div>
        </div>

        {/* 底部按钮 */}
        <button
          onClick={() => navigate("/lockUp")}
          className="w-full md:w-auto px-8 py-3 mt-8 bg-gradient-primary rounded-lg font-medium text-white hover:opacity-90 transition-opacity"
        >
          {translate(getText("我要參與"))}
        </button>
      </div>
    </div>
  );
}
